import { defineStore, storeToRefs } from "pinia"
import { ref } from "vue"
import { sleep } from "@/helpers/util"
import { useSyncStore } from "@/stores/sync"
import { useApiStore } from "@/stores/api"

export const useCommandStore = defineStore(
	"command",
	() => {
		const debug = false
		const flushCommandInProgress = ref(false)
		const logoutCommandInProgress = ref(false)

		const execute = async (command) => {
			switch (command) {
				case "sync:flush":
					await syncFlush()
					break
				case "auth:logout":
					await authLogout()
					break
			}
		}

		const syncFlush = async () => {
			if (flushCommandInProgress.value) return
			if (debug) console.log("🫡 sync:flush")
			flushCommandInProgress.value = true
			const syncStore = useSyncStore()
			const { initialized, syncInProgress } = storeToRefs(useSyncStore())

			while (!initialized.value || syncInProgress.value) {
				if (debug) console.log("🫡 waiting for routeStore to become ready for sync:flush", initialized.value, syncInProgress.value)
				await sleep(500)
			}

			await syncStore.reset()
			await sleep(2000)
			if (debug) console.log("🫡 sync:flush flush complete, syncing...")
			await syncStore.sync()
			if (debug) console.log("🫡 sync:flush sync started, done.")
			flushCommandInProgress.value = false
		}

		const authLogout = async () => {
			if (logoutCommandInProgress.value) return
			if (debug) console.log("🫡 auth:logout")
			logoutCommandInProgress.value = true
			const apiStore = useApiStore()
			await apiStore.logout()
			if (debug) console.log("🫡 auth:logout completed. Starting sync")
			logoutCommandInProgress.value = false
		}

		return {
			execute,
		}
	},
	{
		persist: false,
	}
)
